import { useContext } from 'react';

import AccountRepresentativesContext from './AccountRepresentativesContext';

const useAccountRepresentatives = () => useContext(AccountRepresentativesContext);

export default useAccountRepresentatives;
